<div class="admin-shell">

  <!-- Sidebar -->
  <aside class="admin-sidebar" [class.collapsed]="sidebarCollapsed">

    <div class="sidebar-brand">
      <span class="material-symbols-outlined">admin_panel_settings</span>
      <span class="brand-text">Admin Panel</span>
    </div>

    <nav class="sidebar-nav">

      <a
        routerLink="/admin/dashboard"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">dashboard</span>
        <span class="nav-label">Dashboard</span>
      </a>

      <a
        routerLink="/admin/plans"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">card_membership</span>
        <span class="nav-label">Plan Manager</span>
      </a>

      <a
        routerLink="/admin/users"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">group</span>
        <span class="nav-label">Users</span>
      </a>

      <a
        routerLink="/admin/merchants"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">storefront</span>
        <span class="nav-label">Merchants Review</span>
      </a>

      <a
        routerLink="/admin/brokers"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">handshake</span>
        <span class="nav-label">Brokers Review</span>
      </a>

      <a
        routerLink="/admin/relationship-managers"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">support_agent</span>
        <span class="nav-label">Relationship Managers</span>
      </a>

      <a
        routerLink="/admin/verifications"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">verified_user</span>
        <span class="nav-label">Verifications</span>
      </a>

      <a
        routerLink="/admin/reports"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">report</span>
        <span class="nav-label">Reported Profiles</span>
      </a>

      <a
        routerLink="/admin/support"
        routerLinkActive="active"
        class="nav-item"
        (click)="closeMobileSidebar()">
        <span class="material-symbols-outlined">headset_mic</span>
        <span class="nav-label">Support Tickets</span>
      </a>

    </nav>

    <div class="sidebar-footer">
      <div class="admin-info">
        <span class="material-symbols-outlined">account_circle</span>

        <div class="admin-meta">
          <div class="admin-name">
            {{ adminUser?.name }}
          </div>

          <div class="admin-role">
            {{ adminUser?.role }}
          </div>
        </div>
      </div>

      <button class="btn-logout" (click)="logout()">
        <span class="material-symbols-outlined">logout</span>
      </button>
    </div>

  </aside>

  <!-- Mobile Sidebar Backdrop -->
  <div
    class="sidebar-backdrop"
    [class.visible]="!sidebarCollapsed"
    (click)="closeMobileSidebar()">
  </div>

  <!-- Main Content -->
  <main class="admin-main">

    <div class="admin-topbar">

      <button
        class="btn-toggle-sidebar"
        (click)="toggleSidebar()"
        aria-label="Toggle sidebar">

        <span class="material-symbols-outlined">
          {{ sidebarCollapsed ? 'menu' : 'close' }}
        </span>

      </button>

      <div class="topbar-title">
        {{ pageTitle }}
      </div>

      <div class="topbar-time">
        {{ currentTime | date:'medium' }}
      </div>

    </div>

    <div class="admin-content">
      <router-outlet></router-outlet>
    </div>

  </main>

</div>